/**
 * Handles the interactions with the saved designs page on the frontend customer account view.
 */
export class SavedDesigns {
    /**
     * @var {[key: string]: any} elements dictionary of related HTMLElements on the dom.
     */
    elements: {[key: string]: any};

    /**
     * Instantiate the class and bind the elements.
     */
    constructor() {
        this.elements = {};

        this.bind();
    }

    /**
     * Creates the references and events on the related elements and controls.
     *
     * @returns {void}
     */
    bind() : void {
        this.elements.view_proof_links = document.getElementsByClassName('js-view-proof-opener');
        for (const view_proof_link of this.elements.view_proof_links) {
            view_proof_link.addEventListener('click', this.generatePdfLink.bind(this), false);
        }
    }

    /**
     * Generates the pdf link based on the design_id.
     *
     * @param {Event} event The click event from the modal opener.
     * @returns {void}
     */
    generatePdfLink(event: Event): void {
        const link = <HTMLElement> event.currentTarget;

        const url = 'index.php?dispatch=tv_designtool.generate_pdf';

        $.ceAjax(
            'request',
            url,
            {
                full_render: false,
                method: 'POST',
                caching: false,
                data: {design_id: link.dataset.id},
                callback: response => {
                    const element_name = 'js-proof-' + link.dataset.id;
                    const element = document.getElementById(element_name);
                    element.innerHTML = `<a class="ty-btn ty-btn__secondary" href="${response.url}" target="_blank">View Proof PDF</a>`;
                }
            }
        );
    }
}
